import MessageCircleWhatsappIcon from '@components/v2/icons/MessageCircleWhatsapp';
import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import useAuthContactButton from './hooks/useAuthContactButton';

const AuthContactButton = () => {
  const { href, label } = useAuthContactButton();

  return (
    <Button
      variant="contained"
      color="secondary"
      size="medium"
      href={href}
      endIcon={<Icon icon={MessageCircleWhatsappIcon} size="sm" />}
    >
      {label}
    </Button>
  );
};

export default AuthContactButton;
